/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unread: NonNullable<unknown>, read: NonNullable<unknown> }} Notifications_Footer_BreakdownInputs */

const en_notifications_footer_breakdown = /** @type {(inputs: Notifications_Footer_BreakdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unread} unread · ${i?.read} read`)
};

const pt_br2_notifications_footer_breakdown = /** @type {(inputs: Notifications_Footer_BreakdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.unread} não lidas · ${i?.read} lidas`)
};

/**
* | output |
* | --- |
* | "{unread} unread · {read} read" |
*
* @param {Notifications_Footer_BreakdownInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_footer_breakdown = /** @type {((inputs: Notifications_Footer_BreakdownInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Footer_BreakdownInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_footer_breakdown(inputs)
	return pt_br2_notifications_footer_breakdown(inputs)
});